import { MdAccountBalance, MdDescription, MdOutlineError } from 'react-icons/md';
import { FaSearch, FaPlus } from "react-icons/fa";
import { IoChatbox } from "react-icons/io5";
import HeaderContainers from '../HeaderContainers/HeaderContainers';
import InputPadrao from '../InputPadrao/InputPadrao';
import './FiltroEmpresaContainer.css';
import InputSelectPadrao from '../InputSelectPadrao/InputSelectPadrao';
import BotaoCustom from '../BotaoCustom/BotaoCustom';
import BotaoPadrao from '../BotaoPadrao/BotaoPadrao';
import { EmpresaFilterContext } from '../../context/EmpresaFilterContext';
import { useContext, useEffect, useState } from 'react';
import { getSituacaoCadastro } from '../../services/situacaoCadastroService';
import NotifyUtils from '../../utils/NotifyUtils';
import { useTranslation } from 'react-i18next';


function FiltroEmpresaContainer({
    podeCadastrar,
}) {

    const { t } = useTranslation();

    const { handleClear, empresaFilter, handleChange, handleSearch } = useContext(EmpresaFilterContext);
    const [ resetaFiltroSitCadastro, setResetaFiltroSitCadastro ] = useState(false);

    const limparFiltros = () => {
        NotifyUtils.sucesso(t("retira-filtros"));
        setResetaFiltroSitCadastro(!resetaFiltroSitCadastro);
        handleClear();
    };

    const pesquisar = () => {
        handleSearch();
        NotifyUtils.sucesso(t("pesquisa-sucesso"));
    }

    const [situacaoCadastro, setSituacaoCadastro] = useState(null);
    useEffect(() => {
        getSituacaoCadastro().then((situacaoCadastro) => {
            setSituacaoCadastro(situacaoCadastro);
        }).catch((error) => {
            console.error(error);
        });
    }, []);

    let situacoesCadastro = [];

    if (situacaoCadastro !== null) {
        situacoesCadastro = situacaoCadastro;
    } else {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <HeaderContainers texto= {t("selecione-filtros")} />

            <div className="container-filtro-empresas">
                <div className="container-razao-sigla-endereco">
                    <InputPadrao
                        className={"input-razao-social-filtro-empresa"}
                        titulo={t("razao-social")}
                        icone={<MdAccountBalance />}
                        placeholder={t("place-holder-razao-social")}
                        obrigatorio={false}
                        type={"text"}
                        name={"razao-social"}
                        onChange={handleChange}
                        value={empresaFilter.razaoSocial}
                        inputPara={"razaoSocial"}
                    />

                    <InputPadrao
                        className={"input-sigla-filtro-empresa"}
                        titulo={t("sigla")}
                        icone={<IoChatbox />}
                        placeholder={t("place-holder-siglas")}
                        obrigatorio={false}
                        type={"text"}
                        name={"sigla"}
                        onChange={handleChange}
                        value={empresaFilter.sigla}
                        inputPara={"sigla"}
                    />

                    <div className="flex-blank"></div>
                </div>

                <div className="container-low-filtro-empresas">
                    <div className="container-documentos-e-situacao-filtro-empresas">
                        <InputPadrao
                            className={"input-documento-filtro-empresa"}
                            inputPara={"numDocumento"}
                            titulo={t("numero-documento")}
                            icone={<MdDescription />}
                            placeholder={t("place-holder-cpf")}
                            obrigatorio={false}
                            type={"text"}
                            name={"numero-documento"}
                            value={empresaFilter.numDocumento}
                            onChange={handleChange}
                        />

                        <InputSelectPadrao
                            className={"input-situacao-cadastro-filtro-empresa"}
                            titulo={t("situacao-cadastro")}
                            obrigatorio={false}
                            name={"situacao-cadastro"}
                            inputPara={"situacaoCadastro"}
                            placeholder={t("place-holder-sitCad")}
                            options={situacoesCadastro}
                            onChange={handleChange}
                            icone={<MdOutlineError />}
                            value={empresaFilter.situacaoCadastro}
                            sendAll={true}
                            resetaFiltro={resetaFiltroSitCadastro}
                        />

                        <div className="flex-blank"></div>
                    </div>

                    <div className="botoes-filtro-empresas">

                        <BotaoPadrao
                            texto={t("botao-limpa-filtros")}
                            icone={null}
                            acaoDeClicar={limparFiltros}
                        />

                        <BotaoCustom
                            acaoDeClicar={pesquisar}
                            icone={<FaSearch />}
                            texto={t("botao-pesquisar")}
                            cancelar={false}
                        />

                        {podeCadastrar && (
                            <BotaoCustom
                                redirecionar={"/cadastrar-empresa"}
                                icone={<FaPlus />}
                                texto={t("botao-cadastra-empresa")}
                                cancelar={true}
                            />
                        )}
                        
                    </div>
                </div>

            </div>
        </div>
    )
}

export default FiltroEmpresaContainer;